import { RootState } from "@/app/stores"
import { getGroups, IGroup } from "@/shared/api/groups"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchUsersGroups = createAsyncThunk<
    IGroup[],
    void,
    { state: RootState }
>('groups/fetchUsersGroups', async(_, thunkAPI) => {
    try {
        const data = await getGroups('users')
        return data.data.items
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchEmployeesGroups = createAsyncThunk<
    IGroup[],
    void,
    { state: RootState }
>('groups/fetchEmployeesGroups', async(_, thunkAPI) => {
    try {
        const data = await getGroups('employees')
        return data.data.items
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})